<template>
	<div class="structure">
		<img class="img" :src="item1"/>
		<img class="img" :src="item2"/>
		<img class="img" :src="item3"/>

	</div>
</template>

<script>
export default {
	name: "Structure",
	data() {
		return {
			item1: require('@/assets/structure/2.png'),
			item2: require('@/assets/structure/3.png'),
			item3: require('@/assets/structure/4.png'),

			background: require('@/assets/structure/background.png'),
		}
	},
	methods: {},
	created() {

	},
	computed: {},
	watch: {},
}
</script>

<style lang="scss" scoped>
.structure {
	position: relative;
	// height: 894px;
	width: 1920px;
	.img{
		width: 100%;
	}
	.background {
		position: absolute;
		width: 100%;
		height: 894px;
		.background_img{
			width: 100%;
			height: 894px;
		}
	}
	.structure_content {
		position: absolute;
		width: 100%;
		height: 894px;
		/* 子元素居中 */
		display: flex;
		justify-content: center; /* 子元素水平居中 */
		.content_wrap{
			width: 1501px;
			height: 894px;

		}
	}
}

.top {
	height: 218px;
}

.top1 {
	width: 100%;
	height: 47px;
	padding-top: 71px;
	/** 文本1 */
	font-size: 32px;
	font-weight: 700;
	letter-spacing: 0;
	line-height: 46.34px;
	color: rgba(34, 34, 34, 1);
	text-align: center;
	vertical-align: top;
}

.top2 {
	width: 100%;
	height: 77.72px;
	margin-top: 28px;
	/** 文本1 */
	font-size: 16px;
	font-weight: 300;
	letter-spacing: 0;
	line-height: 23.17px;
	color: rgba(102, 102, 102, 1);
	text-align: center;
	vertical-align: top;
}

.botton {
  width: 1501px;
	height: 519px;
  .bottom-img {
    width: 1501px;
    height: 519px;
  }
}

</style>